import { useState } from "react";
import { connect } from "react-redux";
import jwt_decode from "jwt-decode";
import { useNavigate, useSearchParams } from "react-router-dom";
import { appleAuthHelpers } from "react-apple-signin-auth";

import { apiCallV2 } from "../../utils/api";
import { delay } from "../../utils";
import CustomLoader from "../CustomLoader";

import { CallImpactConversion } from "../../redux/v2/impact/actions";
import { SetUserDetails, CheckRequirementsAndRedirectV2, LoadUserData, LoadFavorites, LoadFinishedWorkoutsIDs } from "../../redux/v2/user/actions";

import toast from "react-hot-toast";
import AppleIcon from "@mui/icons-material/Apple";
import CustomButton from "../CustomButton";

import "./style.css";

function CustomAppleAuth(props) {
    const { authType } = props;

    const [searchParams, setSearchParams] = useSearchParams();
    const offer = searchParams.get("offer");

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const proceedSignup = async (data, tokenDetails) => {
        if (props?.hasOwnProperty("proceedSignup")) {
            props?.proceedSignup({
                email_address: tokenDetails.email,
                first_name: tokenDetails?.firstName,
                last_name: tokenDetails?.lastName,
                auth_provider: "apple",
                auth_provider_details: {
                    ...data.authorization,
                    authorizationCode: data.authorization.code,
                    token_email: tokenDetails.email,
                    user: tokenDetails.user_apple_id,
                },
                medium: "web",
            });
        } else {
            const irclickid = localStorage.getItem("irclickid");

            const res = await apiCallV2("POST", "signup-using-auth-provider", {
                email_address: tokenDetails.email,
                first_name: tokenDetails?.firstName,
                last_name: tokenDetails?.lastName,
                auth_provider: "apple",
                auth_provider_details: {
                    ...data.authorization,
                    authorizationCode: data.authorization.code,
                    token_email: tokenDetails.email,
                    user: tokenDetails.user_apple_id,
                },
                medium: "web",
            });

            setLoading(false);

            if (res.data.status == 200) {
                props.SetUserDetails({
                    first_name: tokenDetails.firstName,
                    last_name: tokenDetails.lastName,
                    user_name: tokenDetails.email,
                    email_address: tokenDetails.email,
                });

                if (irclickid) {
                    props.CallImpactConversion(irclickid, res.data.data.access_token, tokenDetails.email);
                }

                localStorage.setItem("access-token", res.data.data.access_token);
                localStorage.setItem("requirement_status", 0);

                navigate("/personal-info");
            } else if (res.data.status == 409) {
                toast.error(res.data.message);
            } else {
                toast.error("Failed to Register new User");
            }
        }
    };

    const proceedLogin = async (data, tokenDetails) => {
        const res = await apiCallV2("POST", "login-using-auth-provider", {
            medium: "web",
            auth_userId: tokenDetails.user_apple_id,
            email_address: tokenDetails.email,
            auth_provider: "apple",
            details: {
                ...data.authorization,
                authorizationCode: data.authorization.code,
                user: tokenDetails.user_apple_id,
            },
        });

        if (res && res.data.status === 200) {
            const requirementStatus = res.data.data.requirement_status;

            localStorage.setItem("access-token", res.data.data.access_token);
            localStorage.setItem("email", res.data.data.email_address);
            localStorage.setItem("username", res.data.data.email_address);
            localStorage.setItem("requirement_status", requirementStatus);
            localStorage.setItem(
                "indi-new-user-details",
                JSON.stringify({
                    name: {
                        first: res.data.data.first_name,
                        last: res.data.data.last_name,
                    },
                })
            );

            props.LoadUserData();
            props.LoadFavorites();
            props.LoadFinishedWorkoutsIDs();

            props.SetUserDetails(res.data.data);

            delay(() => {
                setLoading(false);
            }, 10000);

            if (res.data.data.is_billing_info_present) {
                if (res.data.data.is_survey_done && res.data.data.first_name && res.data.data.last_name) {
                } else {
                    localStorage.setItem("survey_not_done", res.data.data.is_survey_done);
                }
            } else {
                navigate(process.env.PUBLIC_URL + (offer ? `/choose-plan?offer=${offer}` : "/choose-plan"));
            }
            // if (requirementStatus != 0) {
            props.CheckRequirementsAndRedirectV2(navigate);
            // }
        } else {
            setLoading(false);
            toast.error(res.data.message);
        }
    };

    const authenticate = async () =>
        await appleAuthHelpers.signIn({
            authOptions: {
                clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                redirectURI: process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APPLE_REDIRECT_URL : process.env.REACT_APP_APPLE_REDIRECT_URL_DEV,
                scope: "email name",
                state: "state",
                nonce: "nonce",
                usePopup: true,
            },
            onSuccess: (response) => {
                setLoading(true);
                localStorage.setItem("apple", JSON.stringify(response));

                const tokenDetails = jwt_decode(response?.authorization?.id_token);
                // localStorage.setItem("apple-data-token", tokenDetails);
                const data = {
                    username: tokenDetails?.email,
                    password: tokenDetails?.sub,
                    user_apple_id: tokenDetails?.sub,
                    email: tokenDetails?.email,
                    firstName: response?.user?.name?.firstName,
                    lastName: response?.user?.name?.lastName,
                };

                localStorage.setItem("apple-data", JSON.stringify(data));

                if (response && data) {
                    if (authType == "signup") {
                        proceedSignup(response, data);
                    } else if (authType == "signin") {
                        proceedLogin(response, data);
                    }

                    // onSubmit("apple", undefined, data)
                } else {
                    // setAlertVariant('danger')
                    toast.error("Failed to Authenticate AppleID");
                    // setAlertMessage('Signup failed')
                    // onAlertOpen()
                }
            },
            onError: (error) => {
                if (error.error !== "popup_closed_by_user") {
                    toast.error("Unable to continue Apple Authentication");

                    // setAlertVariant('danger')
                    // setAlertMessage(startCase(error.error))
                    // onAlertOpen()
                }
            },
        });

    return (
        <>
            <CustomButton onClick={props?.onClick || authenticate} className="apple-auth-button">
                <AppleIcon sx={{ color: "#fff" }} />
                {authType == "signin" ? "Login with Apple" : "Sign Up with Apple"}
            </CustomButton>

            {loading && <CustomLoader loading={loading} />}
        </>
    );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    CallImpactConversion,
    SetUserDetails,
    CheckRequirementsAndRedirectV2,
    LoadUserData,
    LoadFavorites,
    LoadFinishedWorkoutsIDs,
})(CustomAppleAuth);
